export const environment = {
  production: true,
  rapi: 'https://api.ltsnhelp.com',
  multisite: {
    name: 'freeplay-mega',
    view: '.freeplay', // name from view to use on this template
    apiresources: 'https://d3tmfelegj51yl.cloudfront.net/lp-freeplay/powerball-megamillions/', // url where are all json resource
    defaultLang: { lenid: 'en', lennombre: 'English' }, //default language for this langing
    langs: [
      { lenid: 'en', lennombre: 'English' },
      { lenid: 'es', lennombre: 'Español' },
      { lenid: 'pt', lennombre: 'Portugues' }
    ] //all language for this landing
  },
  sentry: {
    dsn: 'https://8122d2bf17a14a61b01885af3a9f4e90@sentry.io/5029794', // dsn sentry
    reportDialog: false, // show report dialog
    enable: false, // if is true logs to sentry are send
    logs: false // enable local logs
  },
  environment: 'freeplay-mega.production', // used to sentry enviroment type
  version: '34518d6a__20240819_164712__1321', // use this with global enviroment and numero commit/fecha-time/build-number
  lottery: {
    lot_id: 2,
    synd_prc_code: {
      wt: 80,
      ltk: 109
    }
  },
  pcode: {
    wt: null,
    ltk: null
  },
  type: 'freeplay',
  product_type: 2,
  product_id: 133,
  pick_type: 1,
  source: 'ng-freeplay-mega',
  domainRestriction: null,
  upsellPage: null,
  promoSyndicate: true,
  templateIdPromoWT: 150,
  templateIdPromoLTK: 151,
  AES_CODE: '0PC0s9#MrgPHaJHi'
};
